<template>
  <v-card class="d-flex flex-column justify-center align-center ma-4">
    <div>ERROR</div>
    <div class="text-h1">{{ error.statusCode }}</div>
    <div>{{ error.message }}</div>
    <v-btn text color="var(--bg)" to="/" exact>Back to main page</v-btn>
  </v-card>
</template>

<script>
import { IS_MOBILE_VIEWPORT } from "@/pages/constant";

export default {
  name: "LayoutError",
  layout: !IS_MOBILE_VIEWPORT ? "default" : "mobile",
  props: ["error"],
  data() {
    return {
      redirection: null,
    };
  },
  computed: {
    isMobile() {
      return this.$ui.isMobileView();
    },
  },
  created() {
    // set footer template
    this.$store.dispatch("mobile/setFooterTemplate", {
      type: null,
    });
    // set button active
    this.$store.dispatch("mobile/setButtonActive", {
      button: ".btn-dashboard",
    });
    // set header icon left
    this.$store.dispatch("mobile/setHeaderIconLeft", {
      type: "icon",
    });
    // set header icon right
    this.$store.dispatch("mobile/setHeaderIconRight", {
      type: null,
    });
    // reset page title
    this.$store.dispatch("app/setPageInfo", {
      pageTitle: "",
    });
  },
};
</script>
